import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-VIP_select",
  "use": "icon-VIP_select-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-VIP_select\"><path d=\"m6 0c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-3.26 6.39 2.29 2.29c.15.15.36.24.57.24s.42-.09.57-.24l4.02-4.02c.15-.15.24-.36.24-.57s-.09-.42-.24-.57-.36-.24-.57-.24-.42.09-.57.24l-3.45 3.45-1.72-1.72c-.15-.15-.36-.24-.57-.24s-.42.09-.57.24-.24.36-.24.57.09.42.24.57z\" fill=\"#f2d9b4\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/VIP_select.svg
// module id = VLPv
// module chunks = 87